import urls from '../constants/urls.js';
import { fetch } from 'domain-task';
import BaseService from './baseService';

class BlogService {   
    static getPosts(articleType, page, sections, tags) {
        let sectionsQuery = '';
        sections.forEach(section => {
            sectionsQuery += `&sections=${encodeURIComponent(section)}`;
        });
        let tagsQuery = '';
        tags.forEach(tag => {
            tagsQuery += `&tags=${encodeURIComponent(tag)}`;
        });
        return BaseService.getAndReturn(`/Blog/Articles?articleType=${articleType}&page=${page}${sectionsQuery}${tagsQuery}`, BaseService.returnAssignedObject, 'Unable to fetch blog posts', true, 'Unable to fetch blog posts');
    }

    static getSections(articleType) {
        return BaseService.getAndReturn(`/Blog/Sections?articleType=${articleType}`, BaseService.returnAssignedArray, 'Unable to fetch blog sections', false);
    }

    static getTags(articleType) {
        return BaseService.getAndReturn(`/Blog/Tags?articleType=${articleType}`, BaseService.returnAssignedArray, 'Unable to fetch blog tags', false);
    }

    static getArticle(link) {
        return BaseService.getAndReturn(`/Blog/Articles/${link}`, BaseService.returnAssignedObject, 'Unable to fetch article', true, 'Unable to fetch article');
    }

    static getArticleShares(url) {
        return BaseService.getAndReturn(`/Blog/ArticleShares?url=${url}`, BaseService.returnAssignedObject, 'Unable to fetch article shares', false);
    }
}
export default BlogService;